import PropTypes from 'prop-types';

import ErrorList from 'components/checkout/caap/ErrorList';
import { Row, RowSpan } from 'components/checkout/caap/Layout';

const ErrorAlert = ({ constraintOverlayMessage }, { testId }) => {
  const errorList = constraintOverlayMessage ? [constraintOverlayMessage] : [];

  if (!errorList.length) {
    return null;
  }

  errorList.unshift('There is a problem with your order.');

  return (
    <Row>
      <RowSpan span="12" data-test-id={testId('errorList')}>
        <ErrorList errorHeading="Important Message" errorList={errorList} />
      </RowSpan>
    </Row>
  );

};

ErrorAlert.contextTypes = {
  testId: PropTypes.func
};

export default ErrorAlert;
